import {
    FETCHED_LABELS,
    FETCHED_LABEL,
    FETCH_LABEL_TYPES,
    UPDATED_LABEL,
    DELETED_LABEL,
    FETCHED_LABEL_TRANSLATIONS,
    FETCHED_LABEL_TRANSLATION,
    DELETED_LABEL_TRANSLATION,
    EDIT_LABELS_TEXT_FIELD_INLINE,
    GET_LABEL_TRANSLATION_FOR_SITE
} from './types';
import update from 'immutability-helper';
import _sortBy from 'lodash/sortBy';

const INITIAL_STATE = {
    all: [],
    label: {},
    labelTypes: [],
    labelTranslations: [],
    labelTranslation: {},
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        case FETCHED_LABELS:

            return update(state, {
                all: {$set: action.payload.data}
            });

        case FETCHED_LABEL:

            return update(state, {
                label: {$set: action.label}
            });

        case FETCH_LABEL_TYPES:

            let sortedLabelTypes = _sortBy(action.labelTypes, 'display_name');

            return update(state, {
                labelTypes: {$set: sortedLabelTypes}
            });

        case UPDATED_LABEL:
            return update(state, {
                label: {$set: action.label}
            });

        case DELETED_LABEL:

            let allLabels = state.all.filter(item => item.id !== action.labelId);

            return update(state, {
                all: {$set: allLabels}
            });

        case FETCHED_LABEL_TRANSLATIONS:

            return update(state, {
                labelTranslations: {$set: action.labelTranslations},
            });

        case FETCHED_LABEL_TRANSLATION:

            return update(state, {
                labelTranslation: {$set: action.labelTranslation}
            });

        case GET_LABEL_TRANSLATION_FOR_SITE:

            let translationForSite = state.labelTranslations.filter(translation => translation.site_id === action.siteId);

            if (translationForSite[0] === undefined) {
                translationForSite[0] = {
                    display_name: '',
                    site_id: action.siteId,
                  };
            }

            return update(state, {
                labelTranslation: {$set: translationForSite[0]},
            });
        
        case EDIT_LABELS_TEXT_FIELD_INLINE:

            return update(state, {
                labelTranslation: {$merge: {
                    display_name: action.translatedName
                }}
            });

        case DELETED_LABEL_TRANSLATION:

            let allLabelTranslations = state.labelTranslations.filter(item => item.id !== action.translationId);

            return update(state, {
                labelTranslations: {$set: allLabelTranslations}
            });

        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/containers/labels/reducer.js